import { computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

export abstract class GroupBase {
  @bindable label: string | string[] = '';

  @computedFrom('label')
  get labels() {
    return !this.label ? [] : Array.isArray(this.label) ? this.label : [this.label];
  }
}
